<template>
  <div class="text-right" :class="showBlock?'goTop':''">
    <div class="hound">
      <img
          class="returns"
          @click="returnBtn"
          src="../../assets/guild/return.png"
          alt=""
      />
      <p>{{ $t("withdrawalLogin.title2") }}</p>
    </div>

    <div class="head">
      <div class="title">{{ detailsObj.withdrawAmount }}</div>
      <div class="money">{{ detailsNewObj.cc }} {{ detailsNewObj.num }}</div>
      <div class="box">
        <img
            class="head-img"
            src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
            alt=""
        />
        <div class="head-txt">{{ detailsNewObj.usd }}</div>
      </div>
    </div>

    <div class="body">
      <div class="body-txt">{{ detailsObj.pntip }}</div>
      <div class="body-box">
        <img class="body-img" :src="detailsObj.pnlogo" alt="" />
        <!-- <button @click="go(detailsObj.pnurl)" class="body-btn">
          {{ $t("withdrawalLogin.getAccount") }}
        </button> -->
      </div>
    </div>


    <div class="pay">
      <span class="payid">{{ $t("withdrawalLogin.name") }}</span>
      <input class="pay-ipt" v-model="name" :placeholder="$t('withdrawalLogin.nameTips')"/>
      <span v-show="namesta" class="errtxt">{{ $t("withdrawalLogin.nametsa") }}</span>
    </div>

    <div class="pay">
      <span class="payid">{{ $t("withdrawalLogin.documentType") }}</span>
      <select class="pay-ipt" v-model="document_type">
        <option value="CPF" selected=selected>CPF</option>
        <option value="CNPJ">CNPJ</option>
      </select>
    </div>

    <div class="pay">
      <span class="payid">{{ $t("withdrawalLogin.documentId") }}</span>
      <input class="pay-ipt" v-model="document_id" 
      :placeholder="$t('withdrawalLogin.documentIdTips')"
      @focus="showBlockBottom('0.4')"
        @blur="hideBlockBottom"/>
      <span v-show="document_idsta" class="errtxt">{{ $t("withdrawalLogin.documentIdtsa") }}</span>
    </div>

    <div class="pay">
      <span class="payid">{{ $t("withdrawalLogin.accountType") }}</span>
      <select class="pay-ipt" v-model="account_type">
        <option value="CPF" selected=selected>CPF</option>
        <option value="CNPJ">CNPJ</option>
        <option value="PHONE">PHONE</option>
        <option value="EMAIL">EMAIL</option>
        <option value="EVP">EVP</option>
      </select>
    </div>

    <div class="pay">
      <span class="payid">{{ $t("withdrawalLogin.accountId") }}</span>
      <input class="pay-ipt" v-model="account"  
      :placeholder="$t('withdrawalLogin.accountIdTips')"
      @focus="showBlockBottom('0.5')"
        @blur="hideBlockBottom"/>
      <span v-show="accountsta" class="errtxt">{{ $t("withdrawalLogin.accountIdtsa") }}</span>
    </div>

    <div class="pay">
      <span class="payid">{{ detailsObj.whatsAppMessage }}</span>
      <input class="pay-ipt" v-model="id" type="number"  
        :placeholder="$t('withdrawalLogin.WhatsappTips')"
        @focus="showBlockBottom('0.7')"
        @blur="hideBlockBottom"/>
      <span v-show="idsta" class="errtxt">{{ $t("withdrawalLogin.Whatsapp") }}</span>
      <div class="pay-txt">{{ detailsObj.pnotherTip }}</div>
    </div>

    <button
        :disabled="num == '' ? true : false"
        class="anbtn"
        :class="{ bg: num == '' ? true : false }"
        @click="submit"
    >
      {{ $t("withdrawalLogin.Confirm") }}
    </button>
    <div v-if="changeMate" class="meta">
      <div class="meta-box">
        <van-loading
            v-if="display"
            type="spinner"
            color="#cccccc"
            size="120px"
        />
        <van-icon v-else name="success" size="120px" color="#00d293" />
      </div>
      <div
          v-if="!display"
          v-html="detailsObj.pnreturnMsg"
          class="meta-txt"
      ></div>

      <button @click="returntwo" class="onBtn">
        {{ $t("roomParty.back") }}
      </button>
    </div>
    <div v-if="showBlock" style="height: 6rem"></div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast,Loading, Icon } from "vant";
export default {
  name: "pixDetails",
  components:{
    VanLoading: Loading,
    VanIcon: Icon
  },
  data() {
    return {
      showBlock: false,
      userInfo: [],
      detailsObj: {},
      detailsNewObj: {},
      num: "",
      id: "",
      statusCha: false,
      idsta: false,
      numsta: false,
      document_idsta: false,
      accountsta: false,
      namesta: false,
      language: "",
      uid: "",
      token: "",
      changeMate: false,
      display: true,
      deviceId: "",
      accountType: "",
      name: "",
      document_id: "",
      document_type: "",
      account: "",
      account_type: "",
    };
  },
  created() {
    var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
    );
    if (ids) {
      ids = ids[0];
    } else {
      ids = "Unknown Device";
    }
    let obj = JSON.parse(this.$route.query.obj);
    this.detailsObj = obj;
    this.detailsObj.pnreturnMsg = this.detailsObj.pnreturnMsg.replace(
        "\n",
        "<br>"
    );
    let newobj = JSON.parse(this.$route.query.newobj);
    this.detailsNewObj = newobj;
    console.log(newobj)
    let data = JSON.parse(localStorage.getItem("data"));
    this.language = data.lang || navigator.language;
    this.uid = data.uid || data.userId;
    this.deviceId = data.deviceId || ids
    this.token = data.token;
    this.num = localStorage.getItem("num");
    this.id = localStorage.getItem("id");
    this.document_id = localStorage.getItem("document_id");
    this.document_type = localStorage.getItem("document_type");
    this.account = localStorage.getItem("account");
    this.account_type = localStorage.getItem("account_type");
    this.name = localStorage.getItem("name");
    if(data.uid){
      this.changeTime()
    }
  },
  mounted() {
    let langs = this.language.substring(0, 2);
    if (langs == "zh") {
      if (this.language == "zh-TW" || this.language == "zh-HK") {
        this.$i18n.locale = "tc";
      } else {
        this.$i18n.locale = "zh";
      }
    } else if (langs == "en") {
      this.$i18n.locale = "en";
    } else if (langs == "ar") {
      this.$i18n.locale = "ar";
    } else if (langs == "tr") {
      this.$i18n.locale = "tr";
    } else if (langs == "es") {
      this.$i18n.locale = "es";
    } else if (langs == "pt") {
      this.$i18n.locale = "pt";
    } else if (langs == "fr") {
      this.$i18n.locale = "fr"
    } else if (langs == "id") {
      this.$i18n.locale = "id"
    } else if (langs == "ms") {
      this.$i18n.locale = "ms"
    } else {
      this.$i18n.locale = "en";
    }
    document.title = this.$t("withdrawalLogin.title2");
    document.querySelector("html").setAttribute("lang", this.$i18n.locale);
  },
  methods: {
    // 底部增加方块站位
    showBlockBottom(num){
      this.showBlock = true;
      this.$nextTick(()=>{
        window.scrollTo(0, window.innerHeight * num);
      })
    },
    // 底部方块隐藏
    hideBlockBottom(){
      this.showBlock = false;
    },
    returnBtn() {
      this.$router.push({
        path:'/withdrawal',
        query:{
          type:1
        }
      });
    },

    go(url) {
      window.location.href = url;
    },

    submit() {
      this.idsta = this.id ? false : true;
      this.document_idsta = this.document_id ? false : true;
      //alert(this.document_idsta);
      this.accountsta = this.account ? false : true;
      this.namesta = this.name ? false : true;
      if (!this.idsta && !this.document_idsta && !this.accountsta && !this.namesta) {
        this.submitBtn();
      }
    },

    submitBtn() {
      let that = this;

      let dataObj = {}
      if(that.detailsNewObj.id == 0){
        dataObj.cid = that.detailsNewObj.channel + '';
        dataObj.mode = 2;
        dataObj.pocketCoin = that.detailsNewObj.usd
      }else{
        dataObj.cid = that.detailsNewObj.id + "" ;
        dataObj.mode = 1;
      }
      axios({
        url: that.$serviceIp + `/api/trade/card/tx/applyForWeb`,
        method: "post",
        headers: {
          'deviceId': that.deviceId,
          lang: that.lang,
        },
        data: {
          ...dataObj,
          params: { num: that.num, name: that.name, whatsApp: that.id, document_type: that.document_type, document_id: that.document_id, account_type: that.account_type, account: that.account },
        },
        params: { token: that.token, uid: that.uid },
      }).then((res) => {
        if (res.data.code == 200) {
          this.changeMate = true;
          localStorage.setItem("num", that.num);
          localStorage.setItem("name", that.name);
          localStorage.setItem("id", that.id);
          localStorage.setItem("document_type", that.document_type);
          localStorage.setItem("document_id", that.document_id);
          localStorage.setItem("account_type", that.account_type);
          localStorage.setItem("account", that.account);
          setTimeout(this.nshbhxbh, 3000);
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      });
    },
    nshbhxbh() {
      this.display = false;
    },
    returntwo() {
      this.$router.push("/withdrawal");
    },

    changeTime() {
      let item = JSON.parse(localStorage.getItem("time"));
      console.log(item, Date.now());
      if (item < Date.now()) {
        localStorage.removeItem("data");
        localStorage.removeItem("time");
        localStorage.removeItem("num");
        localStorage.removeItem("id");
        localStorage.removeItem("document_type");
        localStorage.removeItem("document_id");
        localStorage.removeItem("account_type");
        localStorage.removeItem("account");
        localStorage.removeItem("name");
        this.$router.push("/withdrawalLogin");
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

html[lang="ar"] .hound {
  -webkit-transform: rotateY(180deg);
}

html[lang="ar"] .body {
  direction: rtl;
}

html[lang="ar"] .pay {
  direction: rtl;
}

.hound {
  width: 100%;
  height: 0.75rem;
  display: flex;
  align-items: center;
  padding-top: 44px;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  position:relative;
}

.returns {
  width: 0.8rem;
  height: 0.8rem;
  position:absolute;
}

.hound p {
  flex: 1;
  font-size: 0.31rem;
  text-align: center;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 18rem;
}
.head {
  width: 5.98rem;
  height: 2.1rem;
  background: linear-gradient(180deg, #ffffff -6.39%, #fff2d0 100%);
  border-radius: 12px;
  margin-top: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.title {
  height: 0.3rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: rgba(123, 124, 132, 1);
}
.money {
  height: 0.53rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 0.44rem;
  line-height: 0.53rem;
  color: #803e39;
}
.box {
  /* height: 0.4rem; */
  display: flex;
  align-items: center;
}
.head-img {
  width: 0.36rem;
  height: 0.36rem;
}
.head-txt {
  height: 0.36rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.3rem;
  line-height: 0.36rem;
  color: #000000;
}

.body {
  width: 5.9rem;
}
.body-txt {
  height: 0.3rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.3rem;
  color: #acadbc;
  margin-top: 0.4rem;
}
.body-box {
  /* height: 0.72rem; */
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body-img {
  width: 1.79rem;
  height: 0.5rem;
}
.body-btn {
  min-width: 2rem;
  height: 0.68rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 0.27rem;
  color: #ffffff;
  background: #00d293;
  border-radius: 27px;
  border: none;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay {
  width: 5.9rem;
  display: flex;
  flex-direction: column;
  margin-top: 0.4rem;
}

.payid {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 17px;
  color: #000000;
}
.pay-ipt {
  width: 5.9rem;
  height: 0.82rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  color: #000000;
  background: #f3f3f5;
  border-radius: 12px;
  border: none;
  padding-left: 0.27rem;
  padding-right: 0.27rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
}
.pay-txt {
  height: 0.58rem;
  color: #acadbc;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.29rem;
  margin-top: 0.2rem;
}
.anbtn {
  width: 4.1rem;
  height: 0.82rem;
  background: #00d293;
  border-radius: 24px;
  border: none;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 0.27rem;
  line-height: 0.82rem;
  text-align: center;
  color: #ffffff;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.errtxt {
  font-size: 0.24rem;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  line-height: 0.29rem;
  color: #ff5c38;
}
.bg {
  color: #acadbc;
  background-color: #f3f3f5;
}

.meta {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.meta-box {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meta-txt {
  width: 85%;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 20px;
  color: #000000;
  text-align: center;
}

.onBtn {
  width: 2.5rem;
  height: 0.82rem;
  font-size: 0.27rem;
  color: #ffffff;
  font-family: PingFang SC;
  border-radius: 12px;
  text-align: center;
  line-height: 0.82rem;
  background-color: #00d293;
  border: none;
  box-sizing: border-box;
  margin-top: 0.6rem;
}
.goTop{
  height: 24rem;
  /* transform: translateY(-5rem); */
}
</style>

